import { render, staticRenderFns } from "./LoginOAuth.vue?vue&type=template&id=e95ffdec&scoped=true&"
import script from "./LoginOAuth.vue?vue&type=script&lang=js&"
export * from "./LoginOAuth.vue?vue&type=script&lang=js&"
import style0 from "./LoginOAuth.vue?vue&type=style&index=0&id=e95ffdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95ffdec",
  null
  
)

export default component.exports